import React from "react";
import { Button, Dropdown, Menu, Space, Tag } from "antd";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  AuditOutlined,
  RetweetOutlined,
} from "@ant-design/icons";

export default function TrainingRegistrationsListActions({
  onDelete,
  showSetPaidDownPayment = false,
  showSetPaidOff = false,
  showCancel = false,
  showInvoice = false,
  showReceipt = false,
  onCancel,
  onSetPaidDownpayment,
  onEdit,
  onSetPaidOff,
  onInvoice,
  onReceipt,
  onReschedule,
  isBundlingChild,
  isBundling,
  bundlingParentId,
}) {
  if (isBundlingChild) {
    return (
      <Space size={4} style={{ whiteSpace: "nowrap" }} direction="vertical">
        <Tag color="blue" style={{ margin: 0 }}>
          Bundling {bundlingParentId}
        </Tag>
        {showCancel && (
          <Button size="small" icon={<RetweetOutlined />} onClick={onReschedule} style={{ margin: 0 }}>
            Reschedule
          </Button>
        )}
      </Space>
    );
  }

  return (
    <Dropdown
      overlay={
        <Menu>
          {!isBundling &&
            <Menu.Item key="4" icon={<EditOutlined />} onClick={onEdit}>
              Edit
            </Menu.Item>
          }
          {showSetPaidDownPayment && (
            <Menu.Item
              key="1"
              icon={<CheckOutlined />}
              onClick={onSetPaidDownpayment}
            // danger
            >
              Tandai lunas dp
            </Menu.Item>
          )}
          {showSetPaidOff && (
            <Menu.Item key="2" icon={<CheckOutlined />} onClick={onSetPaidOff}>
              Tandai lunas total
            </Menu.Item>
          )}
          {showCancel && (
            <>
              {!isBundling &&
                <Menu.Item
                  key="3.5"
                  icon={<RetweetOutlined />}
                  onClick={onReschedule}
                >
                  Reschedule
                </Menu.Item>
              }
              <Menu.Item
                key="3"
                icon={<CloseOutlined />}
                danger
                onClick={onCancel}
              >
                Batalkan
              </Menu.Item>
            </>
          )}
          {showInvoice &&
            <Menu.Item
              key="5"
              icon={<AuditOutlined />}
              danger
              onClick={onInvoice}
            >
              Invoice
            </Menu.Item>
          }
          {showReceipt &&
            <Menu.Item
              key="6"
              icon={<AuditOutlined />}
              danger
              onClick={onReceipt}
            >
              Kuitansi
            </Menu.Item>
          }
          <Menu.Item
            key="0"
            icon={<DeleteOutlined />}
            danger
            onClick={onDelete}
          >
            Hapus
          </Menu.Item>
        </Menu>
      }
      placement="bottomRight"
      trigger={["click"]}
    >
      <i className="gx-icon-btn icon icon-ellipse-v" />
    </Dropdown>
  );
}
